export const AUTH_WINDOW_SIZE = Object.freeze({
	mode: 'auth',
	width: 440,
	height: 620,
	minWidth: 440,
	minHeight: 620,
	maximizable: false
});

export const WORKSPACE_WINDOW_SIZE = Object.freeze({
	mode: 'workspace',
	width: 970,
	height: 660,
	minWidth: 440,
	minHeight: 620,
	maximizable: true
});

function syncWindowLayout(baseLayout, overrides = {}) {
	if (!window.electronAPI || !window.electronAPI.sendEvent) {
		return;
	}

	window.electronAPI.sendEvent('apply-window-layout', {
		...baseLayout,
		...overrides
	});
}

export function syncAuthWindow(overrides = {}) {
	syncWindowLayout(AUTH_WINDOW_SIZE, {
		...overrides,
		mode: 'auth',
		maximizable: false,
		minWidth: overrides.minWidth || AUTH_WINDOW_SIZE.minWidth,
		minHeight: overrides.minHeight || AUTH_WINDOW_SIZE.minHeight
	});
}

export function syncWorkspaceWindow(overrides = {}) {
	syncWindowLayout(WORKSPACE_WINDOW_SIZE, {
		...overrides,
		mode: 'workspace',
		maximizable: overrides.maximizable === undefined || overrides.maximizable === null ? true : overrides.maximizable,
		minWidth: overrides.minWidth || WORKSPACE_WINDOW_SIZE.minWidth,
		minHeight: overrides.minHeight || WORKSPACE_WINDOW_SIZE.minHeight
	});
}
